import { render, staticRenderFns } from "./ClinicCategories.vue?vue&type=template&id=68a278ea&scoped=true"
import script from "./ClinicCategories.vue?vue&type=script&lang=js"
export * from "./ClinicCategories.vue?vue&type=script&lang=js"
import style0 from "./ClinicCategories.vue?vue&type=style&index=0&id=68a278ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a278ea",
  null
  
)

export default component.exports